import {useEffect, useRef, useState} from "react";
import {IoMdAdd} from "react-icons/io";

export default function ApplyCoupon({className, code, clearCode, applyCode, ...props}) {
    const [couponCode, setCouponCode] = useState(code || "");
    const [width, setWidth] = useState(0)

    useEffect(() => {
        let input = document.getElementById("coupon-code")
        if (input) {
            setWidth(input.clientHeight)
        }
    }, [couponCode])
    return (
        <div className={` ${className} relative flex flex-col`}>
            <input
                id={"coupon-code"}
                value={couponCode}

                onChange={(e) => {
                    setCouponCode(e.target.value)
                    clearCode && clearCode()
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        applyCode && applyCode(couponCode)
                    }
                }}
                placeholder={"Enter Coupon Code"}
                className={"px-3 py-1 pr-[40px] w-full focus:outline-none focus:ring-secondary-700 rounded-full ring-2 ring-secondary-900"}
            />
            <div
                style={{
                    width: width || 0
                }}
                onClick={(e) => {
                    applyCode && applyCode(couponCode)
                }}
                className={"  h-[90%] text-white justify-center cursor-pointer items-center flex bg-secondary-900 absolute top-[1px] right-[1px] rounded-full"}>
                <IoMdAdd/>
            </div>
        </div>

    )
}